import { whatIfOrDefaultSelector, whatIfInnerSelector } from '../../../WhatIfsSelector';

export const RETIREMENT = 'retirement';

export const yearsOptionsSelector = (state, props) => {
  const whatIf = whatIfOrDefaultSelector(state, props);

  const whatIfOptions = whatIf.Options || {};

  const yearOptions = (whatIfOptions.YearsOptions || []).map(y => ({
    value: y,
    label: y.toString(),
  }));

  const yearsWithRetirement = [
    {
      value: RETIREMENT,
      label: 'At retirement',
    },
    ...yearOptions,
  ];

  return yearsWithRetirement;
};

export const yearSelector = (state, props) => {
  const selection = whatIfInnerSelector(state, props);
  if (selection.StartAtRetirement) {
    return RETIREMENT;
  }
  return selection.Year;
};
